import { sanitize } from "dompurify";
import { useEffect } from "react";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
import "quill-paste-smart";
import { Delta } from "quill/core";

interface QuillEditorProps {
  defaultValue?: string;
  onChange?: (content: string) => void;
}

const modules = {
  toolbar: [
    ["bold", "italic", "underline", "clean"],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
  ],
};

export const QuillEditor: React.FC<QuillEditorProps> = ({ defaultValue: dirtyDefaultValue, onChange }) => {
  const { quill, quillRef } = useQuill({ modules });

  useEffect(() => {
    if (quill && dirtyDefaultValue && quill.root.innerHTML !== dirtyDefaultValue) {
      const cleanDefaultValue = sanitize(dirtyDefaultValue);
      quill.clipboard.dangerouslyPasteHTML(cleanDefaultValue);
    }
  }, [quill, dirtyDefaultValue]);

  useEffect(() => {
    if (quill) {
      const handleTextChange = (_delta: Delta, _oldDelta: Delta, source: string) => {
        if (source === "user" && onChange) {
          onChange(quill.root.innerHTML);
        }
      };
      quill.on("text-change", handleTextChange);
      return () => {
        quill.off("text-change", handleTextChange);
      };
    }
  }, [quill, onChange]);

  return (
    <div style={{ width: "100%", backgroundColor: "#ffffff" }}>
      <div ref={quillRef} />
    </div>
  );
};
